export default __webpack_public_path__ + "static/media/0x32cd1bcb75473845b5d1db6ece60aec6e41d8518.a5d64a4f.webp";